import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'iterable'})

export class IterablePipe implements PipeTransform {
	transform(dict: any): any[] {

		const a = [];

		for (const key in dict) {
			if (dict.hasOwnProperty(key)) {
				a.push({key, value: dict[key]});
			}
		}

		return a;
	}
}
